import { render, staticRenderFns } from "./identityInformation.vue?vue&type=template&id=b50fe81c&scoped=true&"
import script from "./identityInformation.vue?vue&type=script&lang=js&"
export * from "./identityInformation.vue?vue&type=script&lang=js&"
import style0 from "./identityInformation.vue?vue&type=style&index=0&id=b50fe81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50fe81c",
  null
  
)

export default component.exports